import { buildDemandeStore } from '@/features/interface/demande/shared'
import { proformaService } from '@/features/services/demande'
import {
  getNaturesFichiersProforma as getNaturesFichiers,
  propertyStatusConfiguration,
  reglesConfiguration,
} from '@/features/domaine/regles-akto/PROFORMA'
import type { LovProformaDTO } from '@/features/api/extranet/dto/Demande/PROFORMA'

export const useDemandeProformaStore = buildDemandeStore<'MODEL_PROFORMA', LovProformaDTO>({
  model: 'MODEL_PROFORMA',
  typeDemande: 'Proforma',
  module: 'demande',
  demandeService: proformaService,
  propertyStatusConfiguration,
  reglesConfiguration,
  getNaturesFichiers,
})
